import * as Sentry from '@sentry/nextjs'
import Cookies from 'js-cookie'
import { CommentSortEnum, CommentSortOptions } from 'modules/comments/types'

const COMMENT_SORT_PREFERENCE_KEY = 'comment_sort_preference'

export const getCommentSortPreference = (): CommentSortEnum | null => {
  try {
    const saved = Cookies.get(COMMENT_SORT_PREFERENCE_KEY)
    if (saved && Object.values(CommentSortOptions).includes(saved as CommentSortEnum)) {
      return saved as CommentSortEnum
    }
  } catch (error) {
    Sentry.captureException(error, {
      extra: { context: 'Failed to get comment sort preference' },
    })
  }

  return null
}

export const saveCommentSortPreference = (sortOption: CommentSortEnum): void => {
  try {
    Cookies.set(COMMENT_SORT_PREFERENCE_KEY, sortOption, {
      expires: 365,
      secure: process.env.NODE_ENV === 'production',
      sameSite: 'lax',
    })
  } catch (error) {
    Sentry.captureException(error, {
      extra: { context: 'Failed to save comment sort preference' },
    })
  }
}
